import { Button } from '@components/ui';
import { useTranslation } from '@hooks/useTranslation';
import styles from './ContractReviewBanner.module.scss';

interface ContractReviewBannerProps {
  active: number;
  total: number;
  onRequestActivation: () => void;
  isActivating: boolean;
}

export function ContractReviewBanner({
  active,
  total,
  onRequestActivation,
  isActivating,
}: ContractReviewBannerProps) {
  const { t } = useTranslation();

  const title = t('K_SNAPSHOT_BANNER_PENDING', '{active} of {total} contracts approved')
    .replace('{active}', String(active))
    .replace('{total}', String(total));

  return (
    <div className={`${styles.banner} ${styles.bannerInfo}`}>
      <div className={styles.content}>
        <div className={styles.textBlock}>
          <h3 className={styles.title}>{title}</h3>
          <p className={styles.description}>
            {t('K_SNAPSHOT_BANNER_DESC_PENDING', 'Your contracts are being reviewed by your account manager. You can request activation at any time — review continues in the background.')}
          </p>
        </div>
      </div>
      <Button onClick={onRequestActivation} disabled={isActivating}>
        {isActivating
          ? t('K_LOADING', 'Loading...')
          : t('K_BUTTON_REQUEST_ACTIVATION', 'Request Activation')}
      </Button>
    </div>
  );
}
